import { useState, useEffect } from 'react';
import css from './TnaModSelect.module.css';

import * as tnaServices from '../../../../../services/tnaServices';

import AddEditForm from '../../../_common/elements/forms/AddEditForm';
import FormData from '../../../_common/elements/forms/FormData';
import FormButtons from '../../../_common/elements/forms/FormButtons';

function TnaModSelect({ tnaDetails = {}, toggleModal, method }) {
    const [allModules, setAllModules] = useState([]);
    const [selectedModuleIds, setSelectedModuleIds] = useState(new Set());
    const [initialModuleMap, setInitialModuleMap] = useState(new Map());
    const [assignedModules, setAssignedModules] = useState([]);

    useEffect(() => {
        tnaServices
            .getAssignedModules(tnaDetails.tnaId)
            .then((response) => setAssignedModules(response.data))
            .catch((err) => console.error('Error fetching assigned modules:', err));
    }, [tnaDetails.tnaId]);

    useEffect(() => {
        if (assignedModules && assignedModules.length > 0) {
            const initialSelected = new Set();
            const moduleMap = new Map();

            assignedModules.forEach((module) => {
                initialSelected.add(module.tnaModuleId);
                moduleMap.set(module.tnaModuleId, module.tnaModuleAssignId);
            });

            setSelectedModuleIds(initialSelected);
            setInitialModuleMap(moduleMap);
        }
    }, [assignedModules]);

    useEffect(() => {
        // Fetch all available modules
        const page = 1; // or any other logic to determine the page

        tnaServices
            .getAllModules(page)
            .then((response) => setAllModules(response.data))
            .catch((err) => console.error('Error fetching modules:', err));
    }, [tnaDetails.tnaId]);

    const handleModuleToggle = (tnaModuleId, isChecked) => {
        setSelectedModuleIds((prev) => {
            const newSelected = new Set(prev);
            if (isChecked) {
                newSelected.add(tnaModuleId);
            } else {
                newSelected.delete(tnaModuleId);
            }
            return newSelected;
        });
    };

    const getModuleChanges = () => {
        const currentSelected = Array.from(selectedModuleIds);

        // Find modules to add (selected but not in initial)
        const modulesToAdd = currentSelected
            .filter((moduleId) => !initialModuleMap.has(moduleId))
            .map((moduleId) => ({
                tnaId: parseInt(tnaDetails.tnaId),
                moduleId: moduleId,
                // assignId will be auto-incremented by database
            }));

        // Find modules to remove (in initial but not selected)
        const modulesToRemove = Array.from(initialModuleMap.entries())
            .filter(([moduleId, assignId]) => !selectedModuleIds.has(moduleId))
            .map(([moduleId, assignId]) => ({
                assignId: assignId,
            }));

        return {
            modulesToAdd,
            modulesToRemove,
        };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const changes = getModuleChanges();
        onModulesChange(changes);
        toggleModal();
    };

    const handleCancel = () => {
        toggleModal();
    };

    const onModulesChange = (changes) => {
        console.log('Module changes:', changes);

        // Send to backend API
        tnaServices
            .updateTnaModuleAssigns(tnaDetails.tnaId, changes)
            .then(async () => {
                console.log('Modules updated successfully');
                const refreshed = await tnaServices.getAssignedModules(tnaDetails.tnaId);
                setAssignedModules(refreshed.data);
            })
            .catch((err) => console.error('Error updating modules:', err));
    };

    return (
        <AddEditForm>
            <FormData>
                <div className={css.moduleSelector}>
                    <h3>Select TNA Modules</h3>

                    <div className={css.modulesList}>
                        {allModules.map((module, i) => (
                            <div key={module.tnaModuleId} className={css.moduleCheckbox}>
                                <label className={module.tnaModuleIsForDiff ? css.diffModuleLabel : ''}>
                                    <input
                                        type="checkbox"
                                        checked={selectedModuleIds.has(module.tnaModuleId)}
                                        onChange={(e) => handleModuleToggle(module.tnaModuleId, e.target.checked)}
                                    />
                                    {module.title || module.tnaModuleTitle}
                                    {initialModuleMap.has(module.tnaModuleId) &&
                                        !selectedModuleIds.has(module.tnaModuleId) && (
                                            <span style={{ color: 'red', marginLeft: '8px' }}>(Will be removed)</span>
                                        )}
                                    {!initialModuleMap.has(module.tnaModuleId) &&
                                        selectedModuleIds.has(module.tnaModuleId) && (
                                            <span style={{ color: 'green', marginLeft: '8px' }}>(Will be added)</span>
                                        )}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
                <FormButtons>
                    <button onClick={handleSubmit} className={css.submitButton}>
                        Save Module Selection
                    </button>
                    <button onClick={handleCancel} className={css.cancelButton}>
                        Cancel
                    </button>
                </FormButtons>
            </FormData>
        </AddEditForm>
    );
}

export default TnaModSelect;
